<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="API账号ID">
          <el-input
            v-model="listQuery.api_account_id"
            placeholder="精确查询"
            clearable
            style="width: 120px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="价格方案ID">
          <el-input
            v-model="listQuery.price_plan_id"
            placeholder="精确查询"
            clearable
            style="width: 120px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="丽呈酒店ID">
          <el-input
            v-model="listQuery.hotel_id"
            placeholder="精确查询"
            clearable
            style="width: 120px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="房型ID">
          <el-input
            v-model="listQuery.roomtyp_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="产品ID">
          <el-input
            v-model="listQuery.product_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="价格ID">
          <el-input
            v-model="listQuery.rate_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="房态日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 240px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      stripe
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="API账号ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格方案ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price_plan_id }}
        </template>
      </el-table-column>

      <el-table-column label="丽呈酒店ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_code }}
        </template>
      </el-table-column>

      <el-table-column label="房型ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.roomtyp_id }}
        </template>
      </el-table-column>

      <el-table-column label="产品ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.product_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.rate_id }}
        </template>
      </el-table-column>

      <el-table-column label="业务日期" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.day }}
        </template>
      </el-table-column>

      <el-table-column label="每日价格" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price !== null ? '¥' + scope.row.price : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="可售房量" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.ava_room_cnt !== null ? scope.row.ava_room_cnt + '间' : '-' }}
        </template>
      </el-table-column>

      <el-table-column label="房态开关" min-width="90" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.close_flg === 1" type="danger" size="mini">关房</el-tag>
          <el-tag v-else-if="scope.row.close_flg === 0" type="success" size="mini">开房</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="取消规则ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.cancel_rule_id }}
        </template>
      </el-table-column>

      <el-table-column label="需要更新" min-width="90" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_need_update === 1" type="warning" size="mini">是</el-tag>
          <el-tag v-else-if="scope.row.is_need_update === 0" type="info" size="mini">否</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="同步时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.sync_at }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <el-table-column label="其他" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="hasExtraData(scope.row)">...</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewDetail(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="房态详情"
      :visible.sync="dialogDetailVisible"
      width="800px"
      :close-on-click-modal="true"
    >
      <div class="detail-content">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="API账号ID">
            {{ currentRow.api_account_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="价格方案ID">
            {{ currentRow.price_plan_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="丽呈酒店ID">
            {{ currentRow.hotel_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="酒店编码">
            {{ currentRow.hotel_code || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="房型ID">
            {{ currentRow.roomtyp_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="产品ID">
            {{ currentRow.product_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="价格ID">
            {{ currentRow.rate_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="业务日期">
            {{ currentRow.day || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="每日价格">
            {{ currentRow.price !== null ? '¥' + currentRow.price : '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="可售房量">
            {{ currentRow.ava_room_cnt !== null ? currentRow.ava_room_cnt + '间' : '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="房态开关">
            <el-tag v-if="currentRow.close_flg === 1" type="danger" size="mini">关房</el-tag>
            <el-tag v-else-if="currentRow.close_flg === 0" type="success" size="mini">开房</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="取消规则ID">
            {{ currentRow.cancel_rule_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="是否需要更新">
            <el-tag v-if="currentRow.is_need_update === 1" type="warning" size="mini">是</el-tag>
            <el-tag v-else-if="currentRow.is_need_update === 0" type="info" size="mini">否</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="同步时间">
            {{ currentRow.sync_at || '无' }}
          </el-descriptions-item>
        </el-descriptions>

        <div class="json-section">
          <div class="json-label">礼品ID列表：</div>
          <div v-if="currentRow.gift_id_list" class="json-content">
            <pre>{{ formatJson(currentRow.gift_id_list) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">促销信息：</div>
          <div v-if="currentRow.promotion_list" class="json-content">
            <pre>{{ formatJson(currentRow.promotion_list) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">原始JSON：</div>
          <div v-if="currentRawJson" class="json-content">
            <pre>{{ currentRawJson }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        api_account_id: undefined,
        price_plan_id: undefined,
        hotel_id: undefined,
        roomtyp_id: undefined,
        product_id: undefined,
        rate_id: undefined,
        start_date: undefined,
        end_date: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 日期范围
      dateRange: null,
      // 查看详情弹窗
      dialogDetailVisible: false,
      currentRow: {},
      currentRawJson: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 判断是否有额外数据
    hasExtraData(row) {
      return row.gift_id_list || row.promotion_list || row.raw_json
    },
    // 格式化JSON字符串
    formatJson(jsonStr) {
      if (!jsonStr) return ''
      try {
        const parsed = JSON.parse(jsonStr)
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return jsonStr
      }
    },
    // 获取列表数据
    getList() {
      this.listLoading = true

      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.start_date = this.dateRange[0]
        this.listQuery.end_date = this.dateRange[1]
      } else {
        this.listQuery.start_date = undefined
        this.listQuery.end_date = undefined
      }

      // 处理空值参数
      const params = {}
      Object.keys(this.listQuery).forEach((key) => {
        const val = this.listQuery[key]
        if (val !== '' && val !== undefined && val !== null) {
          params[key] = val
        }
      })

      request({
        url: '/api/backend/liCheng/hotel/roomStatusList',
        method: 'get',
        params: params,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        api_account_id: undefined,
        price_plan_id: undefined,
        hotel_id: undefined,
        roomtyp_id: undefined,
        product_id: undefined,
        rate_id: undefined,
        start_date: undefined,
        end_date: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.dateRange = null
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 查看详情
    handleViewDetail(row) {
      this.currentRow = Object.assign({}, row)
      if (row.raw_json) {
        try {
          const parsed = JSON.parse(row.raw_json)
          this.currentRawJson = JSON.stringify(parsed, null, 2)
        } catch (e) {
          this.currentRawJson = row.raw_json
        }
      } else {
        this.currentRawJson = ''
      }
      this.dialogDetailVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
.detail-content {
  max-height: 500px;
  overflow: auto;
}
.json-section {
  margin-top: 15px;
  .json-label {
    font-weight: bold;
    margin-bottom: 8px;
  }
  .json-content {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    max-height: 150px;
    overflow: auto;
    pre {
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 12px;
      line-height: 1.5;
      color: #333;
    }
  }
  .json-empty {
    text-align: center;
    padding: 15px;
    color: #999;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
}
</style>
